import { FiArrowRight } from 'react-icons/fi';
export default FiArrowRight;

//# sourceMappingURL=LightArrowRight.js.map